export default __webpack_public_path__ + "949eb7441a6e2c36c29fdf18bbb43adf.png";